import { IBaryError } from './bary-error';
import { Estimation } from './estimation.model';

export enum EstimationStatus {
  OK = 'OK',
  QUOTATION_RESPONSE = 'QUOTATION_RESPONSE',
  QUOTATION = 'QUOTATION',
  ERROR = 'ERROR',
}

export interface IEstimateResultModel {
  id?: number;
  status: EstimationStatus;
  quotationMessages: IBaryError[];
  errorMessages: IBaryError[];
  estimation: Estimation;
}

export class LastEstimate {
  id?: number;
  status!: EstimationStatus;
  quotationMessages: string[] = [];
  errorMessages: string[] = [];
  estimation!: Estimation;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.estimation = new Estimation(data.estimation ? data.estimation : {});
  }

  public updateStatus(estimationStatus: EstimationStatus): LastEstimate {
    this.status = estimationStatus;
    return this;
  }
}
